import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import UIIcon from 'UIComponents/icon/UIIcon';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
export default function CollectionRouter({
  linkTo,
  linkText,
  trackInteraction
}) {
  return /*#__PURE__*/_jsxs(UIRouterLink, {
    onClick: () => {
      trackInteraction('click see all link');
    },
    to: linkTo,
    children: [linkText, " ", /*#__PURE__*/_jsx(UIIcon, {
      name: "right"
    })]
  });
}